import { API_DATE_FORMAT, format, getUserValue } from '../../../../../utils';
import { parse } from 'date-fns';
export const getDateValue = (entity, field) => {
    const rawValue = getUserValue(entity, field);
    return rawValue ? format(parse(rawValue, API_DATE_FORMAT, new Date()), 'dd-MM-yyyy') : '';
};
